var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0527344,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#93E9C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_18902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 22.6668C12.3177 22.6668 9.33301 19.6822 9.33301 16.0002C9.33301 12.3182 12.3177 9.3335 15.9997 9.3335C19.6817 9.3335 22.6663 12.3182 22.6663 16.0002C22.6663 19.6822 19.6817 22.6668 15.9997 22.6668ZM15.9997 21.3335C17.4142 21.3335 18.7707 20.7716 19.7709 19.7714C20.7711 18.7712 21.333 17.4147 21.333 16.0002C21.333 14.5857 20.7711 13.2291 19.7709 12.2289C18.7707 11.2287 17.4142 10.6668 15.9997 10.6668C14.5852 10.6668 13.2286 11.2287 12.2284 12.2289C11.2282 13.2291 10.6663 14.5857 10.6663 16.0002C10.6663 17.4147 11.2282 18.7712 12.2284 19.7714C13.2286 20.7716 14.5852 21.3335 15.9997 21.3335ZM15.9997 19.3335C15.1156 19.3335 14.2678 18.9823 13.6427 18.3572C13.0175 17.7321 12.6663 16.8842 12.6663 16.0002C12.6663 15.1161 13.0175 14.2683 13.6427 13.6431C14.2678 13.018 15.1156 12.6668 15.9997 12.6668C16.8837 12.6668 17.7316 13.018 18.3567 13.6431C18.9818 14.2683 19.333 15.1161 19.333 16.0002C19.333 16.8842 18.9818 17.7321 18.3567 18.3572C17.7316 18.9823 16.8837 19.3335 15.9997 19.3335Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_18902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.05273 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.2ab2735270eab23e0fb0835aab2e75a2.svg";
export { ForwardRef as ReactComponent };